import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import column from './column'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import { Table } from 'hljd'
import store from './store'
import { JUKE_PATH_A } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }

  render() {
    const header = [
      <a style={{ color: '#333' }} href={JUKE_PATH_A}>
        聚客宝
      </a>,
      '充值记录'
    ]

    const { list, pagination } = store
    return (
      <HeaderView title="充值记录" header={header}>
        <div style={{ padding: '30px 0' }}>
          <Table
            dataSource={toJS(list)}
            columns={column}
            pagination={pagination}
            onChange={store.setPage}
            rowKey={record => record.id}
          />
        </div>
      </HeaderView>
    )
  }
}
